import {AfterViewInit, ChangeDetectionStrategy, Component, Renderer2} from '@angular/core';
import {environment} from '@env';
import {MatDialogModule} from '@angular/material/dialog';
import {AbstractConfigurationBase} from '@shared/abstracts/abstract-configuration-base';
import { GenericButtonProperties, GenericButtonV2Component } from '@shared/components/button/generic-button-v2/generic-button-v2.component';

@Component({
    selector: 'app-genesys-chat',
    imports: [MatDialogModule, GenericButtonV2Component],
    templateUrl: './genesys-chat.component.html',
    styleUrl: './genesys-chat.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysChatComponent extends AbstractConfigurationBase implements AfterViewInit {

  readonly btnAvaliar: GenericButtonProperties = {
    label: 'Avaliar atendimento',
    idHtml: 'btn-modal-survey',
    dataE2e: 'btn-modal-survey',
    color: 'primary',
    enableBorder: true,
    type: 'button',
  };

  isStartedSearch = false;
  exibirAvaliacao = false;
  exibirAgradecimento = false;
  agentName = '';

  constructor(private renderer: Renderer2) {
    super();
  }

  ngAfterViewInit(): void {
    const isNotExistsScrit = !document.querySelector('script[src="/assets/scripts/chat-genesys.js"]');
    const isNotBackOffice = this.userProfileService.isNotBackOfficeProfile();

    if (isNotExistsScrit && isNotBackOffice) {
      const script = this.renderer.createElement('script');
      this.renderer.setAttribute(script, 'type', 'text/javascript');
      this.renderer.setAttribute(script, 'id', 'scriptGenesys');
      this.renderer.setAttribute(script, 'src', '/assets/scripts/chat-genesys.js');
      this.renderer.setAttribute(script, 'charset', 'utf-8');
      this.renderer.appendChild(document.body, script);

      script.onload = () => {
        this.setAttributesGenesys()
      };
    }
  }

  private setAttributesGenesys(): void {
    window['Genesys']['fila'] = environment.filaChat;
  }


  isShowAgentName(): boolean {
    this.agentName = sessionStorage.getItem('agentName');
    return  this.agentName?.length > 0;
  }

  showFrame() {
    const frameChat = document.querySelector('.genesys-mxg-frame') as HTMLElement;

    if (frameChat) {
      frameChat.style.display = 'block';
    }
  }
}

